import { defineStore } from 'pinia'

// initial state
const state = () => ({
  baseCrumbs: [], // base view crumbs from presenter
  addedCrumbs: [] // added crumbs
});

const getters = {
  crumbs() {
    return [].concat(this.baseCrumbs, this.addedCrumbs)
  }
};

const actions = {
  setBaseCrumbs (baseCrumbs) {
    this.baseCrumbs = baseCrumbs.filter((crumb) => !crumb.added)
    this.addedCrumbs = baseCrumbs.filter((crumb) => crumb.added)
  },
  reset () {
    this.addedCrumbs = []
  },
  addCrumb (title, url) {
    this.addedCrumbs.push({ title, url })
  },
};

export default defineStore({
  id: 'bcBreadCrumbs',
  state,
  getters,
  actions,
});
